import { CompactUserResponse } from '@business/entities/account';
import { ProposalDiscountType } from '@business/entities/proposal';
import { ProposalDiscountFormData } from '@modules/proposal/ProposalBuilderPage/Components/ProposalProductsOverlay';
import { DiscountTypeId } from './DiscountTypeResponse';

export enum TMDiscountSource {
  proposal = 'proposal',
  workOrder = 'work_order',
  changeOrder = 'change_order',
}

export interface TMDiscountInvoiceShare {
  invoiceId: number;
  amount: number;
}

/** One row of a Work Order's discount history. `amount` is frozen in dollars; `allocated` is what invoices carry. */
export interface TMDiscountResponse {
  id: string;
  source: TMDiscountSource;
  sourceLabel: string;
  changeOrderId: string | null;
  discountTypeId: DiscountTypeId | null;
  typeTitle: string | null;
  description: string | null;
  valueType: ProposalDiscountType;
  value: number;
  amount: number;
  allocated: number;
  /** Older Work Orders: the discount is already inside their invoice amounts. */
  inInvoiceAmounts: boolean;
  invoices: TMDiscountInvoiceShare[];
  createdBy: CompactUserResponse | null;
  created: number;
}

/** Work Order billing figures (WorkOrderDiscountHelper::summary). */
export interface WorkOrderBillingSummary {
  originalSubtotal: number;
  changeOrders: number;
  totalDiscounts: number;
  allocatedDiscounts: number;
  unallocatedDiscounts: number;
  contractTotal: number;
  invoiced: number;
  paid: number;
  remainingBalance: number;
  availableForDiscount: number;
  discountLines: boolean;
}

/** A change order's discount as the API returns it: the form values plus its dollar amount. */
export type ChangeOrderDiscountResponse = ProposalDiscountFormData & {
  typeTitle: string | null;
  amount: number;
  isApplied: boolean;
  /** Dollars of it on invoices (once applied). */
  allocated: number;
  /** The invoices carrying it (once applied). */
  invoices: TMDiscountInvoiceShare[];
};
